import { Api } from "@core/api/api";
import { pageParams } from "@core/api/pageParams";
import { Page, PaginationOptions } from "@utils/page";
import { ProfileDto, profileFromDto } from "@domain/user/dtos";
import { Profile } from "@domain/user/profile";
import { LivecourseDto, livecourseFromDto, livecourseToDto } from "./dtos";
import { Livecourse } from "./livecourse";

const LIVECOURSE_URL = "/liveCourse";

export class LivecourseApi {
	constructor(private api: Api) {}

	async get(id: string): Promise<Livecourse> {
		const result = await this.api.get<LivecourseDto>(`${LIVECOURSE_URL}/${id}`);
		return livecourseFromDto(result.data);
	}

	async confirm(id: string): Promise<Livecourse> {
		const result = await this.api.get<Livecourse>(`${LIVECOURSE_URL}/${id}/confirm`);
		return result.data;
	}

	async List(shareroomId: string, by: string): Promise<Page<Livecourse>> {
		const result = await this.api.get<Page<LivecourseDto>>(`${LIVECOURSE_URL}/${by}/${shareroomId}`);
		return { ...result.data, content: result.data.content.map((lc) => livecourseFromDto(lc)) };
	}

	async create(draft: Livecourse): Promise<Livecourse> {
		console.log("livecourseToDto(draft)", livecourseToDto(draft));
		const result = await this.api.post<LivecourseDto>(LIVECOURSE_URL, { ...livecourseToDto(draft) });
		return livecourseFromDto(result.data);
	}

	async save(liveCourse: Livecourse): Promise<Livecourse> {
		const result = await this.api.put<LivecourseDto>(`${LIVECOURSE_URL}/${liveCourse.id}`, {
			...livecourseToDto(liveCourse),
		});
		return livecourseFromDto(result.data);
	}

	async delete(id: string): Promise<void> {
		return this.api.delete(`${LIVECOURSE_URL}/${id}`);
	}

	async getParticipants(id: string, pageOptions: PaginationOptions): Promise<Page<Profile>> {
		const result = await this.api.get<Page<ProfileDto>>(
			`${LIVECOURSE_URL}/${id}/participants?${pageParams(pageOptions)}`
		);
		return { ...result.data, content: result.data.content.map((profile) => profileFromDto(profile)) };
	}
}
